import { round2, safeNumber } from './math'

/** Tax amount over (purchase + operational + other). */
export class TaxCalculator {
  calculate(taxableBase: number, taxPercent: number): number {
    return round2(safeNumber(taxableBase) * (safeNumber(taxPercent) / 100))
  }

  fromAbsolute(value: number): number {
    return round2(Math.max(0, safeNumber(value)))
  }
}
